import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from '../objectUtils';

@Pipe({
    name: 'commonData',
    standalone: false
})
export class CommonDataPipe implements PipeTransform {
  transform(value: any,
    domainDimensions: models.DimensionVM[],
    valueIs: "code" | "id" | "value" = "code",
    show: "desc" | "code-desc" = "desc"
  ): string {
    
    const predicate = valueIs === "code" ? (d: models.DimensionVM) => d.code == value
      : valueIs === "value" ? (d : models.DimensionVM) => d.value == value : (d: models.DimensionVM) => d.dimensionId == value;

    let dim = domainDimensions.find(predicate);
    if (dim == null)
      return value;

    return show == "desc" ? dim.description : dim.code + " - " + dim.description;
  }
}

@Pipe({
    name: 'commonDataList',
    standalone: false
})
export class CommonDataListPipe implements PipeTransform {
  constructor(private commonDataPipe: CommonDataPipe) { }

  transform(value: any[],
    domainDimensions: models.DimensionVM[],
    valueIs: "code" | "id" | "value" = "code",
    show: "desc" | "code-desc" = "desc",
    separator = ';'
  ): string {

    var translatedValues: any[] = [];

    if (!isNullOrUndefined(value)) {
      translatedValues = value?.map((element) => {
        return this.commonDataPipe.transform(element, domainDimensions, valueIs, show);
      })
    }
    return translatedValues.join(separator);
  }
}
